import api from '@/apis/di/budgetFeesAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetFeesTypeReportComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // Lấy dữ liệu là phí
  const onBudgetFeesTypeReportComboboxLoadData = (payload, row, column, customData) => {
    payload.sort = 'budget_fees_code';
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];
    let extend = [{ Field: 'inactive', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);
    let take = 100;
    payload.take = take;
    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const budgetFeesReportComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã phí, lệ phí',
        dataField: 'budget_fees_code',
        width: 200,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên phí, lệ phí',
        dataField: 'budget_fees_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 400,
      },
    ],
    displayField: 'budget_fees_name',
    valueField: 'budget_fees_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetFeesTypeReportComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return {
    budgetFeesReportComboConfig,
    onBudgetFeesTypeReportComboboxLoadData, // trả về thêm để dùng chung cho cả combo không thuộc grid
  };
};
